module.exports = __webpack_public_path__ + "assets/img/img-tutorial03.af0759cf.png";